export default {
  "New layer": "New layer",
  "Elements on layer {0}": "Elements on layer {0}",
  "Layers": "Layers",
  "Project config": "Project config",
  "width": "width",
  "height": "height",
  "Cancel": "Cancel",
  "Save": "Save",
  "Layer config": "Layer config",
  "Name": "Name",
  "opacity": "opacity",
  "altitude": "altitude",
  "order": "order",
  "Delete": "Delete",
  "New project": "New project",
  "Save project": "Save project",
  "Load project": "Load project",
  "3D View": "3D View",
  "2D View": "2D View",
  "3D First Person": "3D First Person",
  "Zoom in": "Zoom in",
  "Zoom out": "Zoom out",
  "Pan": "Pan",
  "Undo (CTRL-Z)": "Undo (CTRL-Z)",
  "Configure project": "Configure project",
  "Open catalog": "Open catalog",
  "Reset": "Reset",
  "Unselect": "Unselect",
  "Configure layer": "Configure layer",
  "Delete layer": "Delete layer",
  "Properties: [{0}] {1}": "Properties: [{0}] {1}",
  "Get Screenshot" : "Get Screenshot",
  "Catalog" : "Catalog",
  "Rotation" : "Rotation",
  "Altitude": "Altitude",
  "Would you want to start a new Project?": "Would you want to start a new Project?",
  "Copy":"Copy",
  "Paste":"Paste",
  "Search Element":"Search Element",
  "Last Selected":"Last Selected",
  "Length":"Length",
  "Lines":"Lines",
  "Holes":"Holes",
  "Items":"Items",
  "Areas":"Areas",
  "Snap to Point":"Snap to Point",
  "Snap to Line":"Snap to Line",
  "Snap to Segment":"Snap to Segment",
  "Snap to Grid":"Snap to Grid",
  "Mouse X Coordinate":"Mouse X Coordinate",
  "Mouse Y Coordinate":"Mouse Y Coordinate",
  "Scene Zoom Level":"Scene Zoom Level"
}



// WEBPACK FOOTER //
// ./src/translator/en.js